/**
 * Named defect: "nothing identifies the project ... no footer with the ministry name,
 * the system name and a build identifier." This is the one place that identifier is
 * resolved, so `Footer` (`@ministry/ui`) never has to guess.
 *
 * `import.meta.env.VITE_BUILD_ID` is Vite's own convention — any `VITE_`-prefixed
 * variable in a `.env` file (or passed at build time, e.g. `VITE_BUILD_ID=$(git
 * rev-parse --short HEAD) vite build`) is exposed here with NO change to
 * `vite.config.ts` or `package.json` (both frozen per this task's brief). A CI/`ship`
 * pipeline can wire a real git SHA or release tag through that variable the moment one
 * exists; until then this falls back to a literal, clearly-labelled placeholder rather
 * than fabricating a version number this build cannot actually verify.
 */
export function getBuildId(): string {
  const injected = (import.meta.env as Record<string, string | undefined>).VITE_BUILD_ID;
  if (injected && injected.trim() !== '') return injected;
  return import.meta.env.DEV ? 'dev' : 'unreleased';
}
